@if (toast$ | async; as toast) {
  <ion-toast
    [isOpen]="toast.isOpen"
    [header]="toast.header"
    [message]="toast.message"
    [duration]="toast.duration"
    [icon]="toast.icon"
    [cssClass]="toast.cssClass"
    [position]="'bottom'"
    [buttons]="toastButtons"
    (didDismiss)="onDidDismiss()"></ion-toast>
}
